import { apiService } from 'core/services/apiService';
import { getCurrentWorkplaceId } from 'core/session/workplaceStore';

export interface ICustomer {
	id?: number;
	firstName: string;
	lastName: string;
	email: string;
	phone?: string | null;
	companyName?: string | null;
	notes?: string | null;
	workplace?: string; // IRI format: "/api/workplaces/id"
}

export interface IPostCustomer {
	firstName: string;
	lastName: string;
	email: string;
	phone?: string | null;
	companyName?: string | null;
	notes?: string | null;
	workplace?: string; // IRI format: "/api/workplaces/id"
}

export interface IUpdateCustomer extends IPostCustomer {
	id: number;
}

export const fetchAllCustomers = async (params?: { pagination?: boolean; workplace?: number }): Promise<any> => {
	const workplaceId = params?.workplace ?? getCurrentWorkplaceId();
	const queryParams: any = {
		pagination: params?.pagination ?? false,
		...(workplaceId && { workplace: workplaceId }),
	};

	const { ...data } = apiService.responseHandler(
		await apiService.get('customer_lists', { params: queryParams })
	);
	return data;
};

export const fetchCustomer = async (customerId: number): Promise<any> => {
	const { ...data } = apiService.responseHandler(
		await apiService.get(`customer_lists/${customerId}`)
	);
	return data;
};

export const postCustomer = async (body: IPostCustomer): Promise<any> => {
	const workplaceId = getCurrentWorkplaceId();
	const payload = {
		...body,
		workplace: body.workplace || (workplaceId ? `/api/workplaces/${workplaceId}` : undefined),
	};

	const { ...data } = apiService.responseHandler(
		await apiService.post('customer_lists', payload)
	);
	return data;
};

export const updateCustomer = async (values: IUpdateCustomer): Promise<any> => {
	const { id, ...body } = values;
	const workplaceId = getCurrentWorkplaceId();
	const payload = {
		...body,
		workplace: body.workplace || (workplaceId ? `/api/workplaces/${workplaceId}` : undefined),
	};

	const { ...data } = apiService.responseHandler(
		await apiService.put(`customer_lists/${id}`, payload)
	);
	return data;
};

export const deleteCustomer = async (customerId: number): Promise<any> => {
	const { ...data } = apiService.responseHandler(
		await apiService.delete(`customer_lists/${customerId}`)
	);
	return data;
};

